import React from 'react';
import { ExternalLink, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { Sidebar } from '../components/Sidebar';
import { TopBar } from '../components/TopBar';
import { previews } from '../data/mockData';

export default function Previews() {
  const handleOpenPreview = (url) => {
    console.log('Opening preview:', url);
  };

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <Sidebar />
      
      <div className="md:ml-64">
        <TopBar />
        
        <main className="p-6 md:p-12 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="space-y-8"
          >
            <div>
              <h1
                className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-2"
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
                data-testid="previews-title"
              >
                Live Previews
              </h1>
              <p className="text-lg text-muted-foreground">
                View your generated applications in real-time
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="previews-grid">
              {previews.map((preview, index) => (
                <motion.div
                  key={preview.id}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.1 }}
                  className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 hover:border-primary/30 transition-all duration-500"
                  data-testid={`preview-card-${preview.id}`}
                >
                  <div className="aspect-video relative overflow-hidden">
                    <img
                      src={preview.thumbnail}
                      alt={preview.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                    
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-sm">
                      <motion.button
                        onClick={() => handleOpenPreview(preview.url)}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        data-testid={`open-preview-${preview.id}`}
                        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-primary to-accent text-white font-semibold shadow-lg shadow-primary/25"
                      >
                        <ExternalLink className="w-5 h-5" />
                        Open Preview
                      </motion.button>
                    </div>
                  </div>

                  <div className="p-6 space-y-3">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1">
                        <h3 className="text-xl font-semibold text-white mb-1" data-testid={`preview-title-${preview.id}`}>
                          {preview.title}
                        </h3>
                        <p className="text-sm text-muted-foreground">{preview.description}</p>
                      </div>
                      {preview.status === 'ready' && (
                        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-green-500/10 text-green-500 border border-green-500/20 text-xs font-medium">
                          <CheckCircle2 className="w-4 h-4" />
                          Ready
                        </div>
                      )}
                    </div>

                    <div className="pt-3 border-t border-white/5">
                      <p className="text-xs text-muted-foreground font-mono" data-testid={`preview-url-${preview.id}`}>
                        {preview.url}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </main>
      </div>
    </div>
  );
}
